module.exports = __webpack_public_path__ + "img/location.6dbd69ae.png";